import { Fragment, useEffect } from 'react'

import { checkCookies, setCookies } from 'cookies-next'
import dayjs from 'dayjs'

import utc from 'dayjs/plugin/utc'
import { useCurrentUserId } from 'lib/use-current-user-id'

interface Props {
  children: React.ReactNode | React.ReactNode[]
}

const SessionStart = ({ children }: Props) => {
  const userId = useCurrentUserId()

  useEffect(() => {
    if (!Boolean(userId)) {
      return
    }

    // if there's a user, we need to track
    // when he/she restarted using the app
    const sessionCookieName = 'tay_user_start'
    if (!checkCookies(sessionCookieName)) {
      dayjs.extend(utc)

      setCookies(sessionCookieName, `${dayjs().utc(true).unix()}`)
    }
  }, [userId])

  return <Fragment>{children}</Fragment>
}

export default SessionStart
